





















































































import { Component, Vue, Watch } from 'vue-property-decorator'

import UiButton from '@/components/semantic-ui/Button'
import UiModal from '@/components/semantic-ui/Modal.vue'
import UiSelectionDropdown from '@/components/semantic-ui/SelectionDropdown.vue'

import HeaderBar from '@/components/HeaderBar'

import { Brand, Category, PantryItem } from '@/datastore/models'

import grocery from '@/store/modules/grocery'

@Component({
	components: {
		HeaderBar,
		UiButton,
		UiModal,
		UiSelectionDropdown,
	},
})
export default class PantryItemDetailsPage extends Vue {

	$refs!: {
		'delete-confirmation-modal': UiModal
	}

	isDeleting = false

	isLoading = false

	isSaving = false

	name = ''

	notes = ''

	selectedBrands: string[] = []

	selectedCategories: string[] = []

	get brands(): Brand[] {

		return grocery.brands
	}

	get categories(): Category[] {

		return grocery.categories
	}

	get item(): PantryItem {

		return grocery.pantryItemsCollection[this.$route.params.id]
	}

	mounted(): void {

		if (this.item) {
			this.setForm(this.item)
		} else {
			this.isLoading = true
		}
	}

	cancel(): void {

		this.$router.back()
	}

	async deleteItem(): Promise<boolean> {

		if (this.item) {
			this.isDeleting = true
			await grocery.deletePantryItem(this.item.$id)
			this.isDeleting = false
			this.$router.back()
		}

		return true
	}

	promptDeleteItem(): void {

		this.$refs['delete-confirmation-modal'].show()
	}

	async save(): Promise<void> {

		this.isSaving = true

		await grocery.updatePantryItem({
			brands: this.selectedBrands,
			categories: this.selectedCategories,
			name: this.name,
			notes: this.notes,
			pantryItemId: this.$route.params.id,
		})

		this.isSaving = false

		this.$router.back()
	}

	@Watch('item')
	onWatchItem(): void {

		if (this.item) {
			this.setForm(this.item)
		}
	}

	private setForm(item: PantryItem): void {

		this.name = item.name
		this.notes = item.notes
		this.selectedBrands = grocery.pantryItemBrands[item.$id]
		this.selectedCategories = grocery.pantryItemCategories[item.$id]

		this.isLoading = false
	}

}

